import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const ctaKit = document.getElementById('cta-kit');
      if (ctaKit) {
        ctaKit.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`bg-gold text-navy font-bold text-lg px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-shadow ${className}`} data-id="element-13">
      {children}
    </motion.button>;
}